import React from 'react';

import wrapStore from '@src/utils/wrap-store';
import InputStore from '@src/pages/main/components/appointment-modal/components/input/store';
import cx from 'classnames';

const styles = require('./index.less');

/**
 * Input
 * @param store {InputStore}
 * @param placeholder
 * @returns {JSX.Element}
 * @constructor
 */
const Input = ({ store, placeholder = '' }) => {
  store.use();
  const renderErrorMessage = () => {
    if (store.isError) {
      return (
        <div className={styles.errorMessageBox}>
          <span className={styles.errorMessage}>{store.errorMessage}</span>
          {/* <span className={styles.errorIcon} /> */}
        </div>
      );
    }
  };
  return (
    <div className={cx(store.isError && styles.errorStatus, styles.inputRoot)} onClick={store.onClick}>
      {/* <div className={styles.border1} data-name="矩形 2 拷贝 7" />
      <div className={styles.border2} data-name="矩形 2 拷贝 6" />
      <div className={styles.border3} data-name="矩形 2 拷贝 5" /> */}
      <div className={styles.inputBg} />
      <input
        className={cx(styles.input)}
        ref={store.inputRef}
        placeholder={!store.isError && placeholder}
        onChange={e => store.valueStore.onChange(e.target.value)}
        maxLength={store.maxLength}
        onFocus={() => (store.isError = false)}
        onBlur={() => store.onBlurToTop && store.onBlurToTop()}
      />
      {renderErrorMessage()}
    </div>
  );
};

export default wrapStore(Input, InputStore);
